import { render, staticRenderFns } from "./SecretVerify.vue?vue&type=template&id=55813265&scoped=true"
import script from "./SecretVerify.vue?vue&type=script&lang=js"
export * from "./SecretVerify.vue?vue&type=script&lang=js"
import style0 from "./SecretVerify.vue?vue&type=style&index=0&id=55813265&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55813265",
  null
  
)

export default component.exports